export const tuiImageEditorTheme = {
    'header.display': 'none',
    'common.bisize.width': '251px',
    'common.bisize.height': '21px',
    'common.backgroundColor': '#FBFCFC',
    'common.border': '0px solid #c1c1c1',
    // main icons
    'menu.normalIcon.color': '#688FA1',
    'menu.activeIcon.color': '#555555',
    'menu.disabledIcon.color': '#434343',
    'menu.hoverIcon.color': '#688fa1',
    'menu.iconSize.width': '24px',
    'menu.iconSize.height': '24px',
    // submenu icons
    'submenu.normalIcon.color': '#688FA1',
    'submenu.activeIcon.color': '#075B6A',
    'submenu.iconSize.width': '32px',
    'submenu.iconSize.height': '32px',
    // submenu primary color
    'submenu.backgroundColor': '#F5F7F7',
    'submenu.partition.color': '#e5e5e5',
    // submenu labels
    'submenu.normalLabel.color': '#688FA1',
    'submenu.normalLabel.fontWeight': 'normal',
    'submenu.activeLabel.color': '#075B6A',
    'submenu.activeLabel.fontWeight': 'normal',
    // checkbox style
    'checkbox.border': '1px solid #ccc',
    'checkbox.backgroundColor': '#fff',
    // rango style
    'range.pointer.color': '#333',
    'range.bar.color': '#ccc',
    'range.subbar.color': '#606060',

    'range.disabledPointer.color': '#d3d3d3',
    'range.disabledBar.color': 'rgba(85,85,85,0.06)',
    'range.disabledSubbar.color': 'rgba(51,51,51,0.2)',

    'range.value.color': '#000',
    'range.value.fontWeight': 'normal',
    'range.value.fontSize': '11px',
    'range.value.border': '0',
    'range.value.backgroundColor': '#f5f5f5',
    'range.title.color': '#000',
    'range.title.fontWeight': 'lighter',
    // colorpicker style
    'colorpicker.button.border': '0px',
    'colorpicker.title.color': '#000',
};
